import React from "react";
import { FaStarOfLife, FaGithub, FaLinkedin, FaWhatsapp } from "react-icons/fa";
import { IoLogoCodepen } from "react-icons/io5";

import "./about.css";

const AboutUs = () => {
  return (
    <div>
      <section className="about" id="about">
        {/* LEFT */}
        <div className="left border1 br5">
          <h1 className="fnt351">
            Hello There!, Codingwithssr - SivasundaraRaj
          </h1>

          <h2 className="fnt352">
            <a href="https://roadmap.sh/frontend"> Senior Web Developer </a>| Frontend Developer | UI/UX Designer, Web Design Company in Chennai, Tamil Nadu,
            India
          </h2>

          <h3 className="textwhite fntlight txtct">
            I have 10+ years of experience in website design in Chennai, creating fast, responsive and user-friendly websites and web applications for businesses.
          </h3>

          <div className="cta">
            <a
              href="mailto:codingiwithssr@gmail.com"
              className="btn"
              style={{ marginRight: "10px" }}
            >
              Enquiry
            </a>

            <a href="tel:9092250561" className="btn-primary">
              Contact Me
            </a>
          </div>
        </div>

        {/* RIGHT */}
        <div className="right">
          <a
            href="https://github.com/sivaraj47"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="GitHub profile"
          >
            <FaGithub className="github" size={28} />
          </a>

          <a
            href="https://www.linkedin.com/in/sivasundararaj-r"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="LinkedIn profile"
          >
            <FaLinkedin className="linkedin" size={28} />
          </a>

          <a
            href="https://wa.me/919092250561"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="WhatsApp contact"
          >
            <FaWhatsapp className="whatsup" size={28} />
          </a>

          <a
            href="https://codepen.io/sivaraj47"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="CodePen profile"
          >
            <IoLogoCodepen className="codepen" size={28} />
          </a>

          <span className="post">UI/UX and Web Developer </span>
{/*<span className="post1">Web Developer</span>*/}

          <img
            src="/ssr.jpg"
            loading="eager"
            fetchpriority="high"
            className="profile"
            alt="Frontend developer and UI UX designer in Chennai and Trichy"
            title="Frontend Developer & UI UX Designer - CodingWithSSR"
          />
        </div>
      </section>

      {/* ROLES */}
      <div className="role">
        <div className="roleinfo">
          <a href="https://www.coursera.org/articles/web-developer" style={{ fontSize: "24px", color: "#000c66", fontWeight: 500 }} > Web Developer </a> <FaStarOfLife />
          <a href="https://www.naukri.com/ui-ux-developer-jobs-in-chennai" style={{ fontSize:"24px", color:"#000c66", fontWeight:500 }}>UI/UX Developer</a><FaStarOfLife />
          <a href="https://webdesigner.withgoogle.com/" style={{ fontSize:"24px",fontWeight:"500",color:"#000c66"}}>Web Designer</a><FaStarOfLife />
          <a href="https://www.figma.com/resource-library/what-is-wireframing/" style={{fontSize:"24px", fontWeight:"500", color:"#000c66"}}>Wireframe</a><FaStarOfLife />
          <a href="https://dribbble.com/tags/mobile-app-design" style={{ fontSize:"24px", fontWeight:"500", color:"#000c66"}}>Mobile App Design</a><FaStarOfLife />
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
